import { TextInput } from '@core/components/Inputs';
import { SelectInput } from '@core/components/Select';
import { FormControlLabel, Grid, Switch } from '@material-ui/core';
import { useFormikContext } from 'formik';
import React from 'react';



const ServicoBuscaAvancadaForm = () => {
  const formik = useFormikContext();

  return (
    <Grid container style={{ padding: 16 }} spacing={3}>
      
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <TextInput
            id="descricao"
            name="descricao"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values?.descricao}
            fullWidth
            label="Nome do serviço prestado"
          />
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <TextInput
          id="codigo"
          name="codigo"
          label="Código de identificação"
          fullWidth
          variant="outlined"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values?.codigo}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <SelectInput
          id="dataInativo"
          name="dataInativo"
          label="Situação"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values?.dataInativo}
          // error={_errors?.situacao}
          // touched={!!_errors?.situacao}              
          options={[
              { id: 'TRUE', title: 'Ativo' },
              { id: 'FALSE', title: 'Inativo' },
              // { id: 'AMBOS', title: 'Ambos' },
            ]}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <FormControlLabel
          control={
            <Switch
              color="primary"
              id="promocao"
              name="promocao"
              value={formik.values?.promocao}
              checked={formik.values?.promocao}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              size="small"
            />
          }
          label="Serviço em promoção"
        />
      </Grid>
    </Grid>
  )
}

export default ServicoBuscaAvancadaForm;